import { Star } from "lucide-react";

export const RatingStars = ({ value = 0, size = 14, className = "" }) => {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`Rated ${value} out of 5`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const filled = i < full || (i === full && half);
        return (
          <Star
            key={i}
            size={size}
            className={filled ? "fill-[#E11B22] text-[#E11B22]" : "text-white/25"}
            strokeWidth={1.5}
          />
        );
      })}
    </span>
  );
};

export default RatingStars;
